<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
/**
 * author: caominjie@tuhu.cn
 * show: 控制citypicker显示隐藏
 * cityPicker: 默认值为3 三级地区选择 (2为两级地区选择)
 * cityValue: 默认选择地区 示例['上海市', '上海市', '闵行区']
 * formatvalue: 格式化数据， 每次数据变化时都会执行  picker实例下的$city为整理好的返回数据
 * onOpen: 自定义 picker 打开时的触发动作
 * onClose:  自定义 picker 关闭时的触发动作
 * el: <tuhu-citypicker :formatvalue='formatvalue' :show='true'>
    </tuhu-citypicker>
 */
import config from '@/configs/config'
import picker from '../commons/picker'
(function($) {
  // this = input
  $.fn.cityPicker = function(params, data, type) {
    const defaultParmas = picker.initPicker(params, {'data': data, 'type': 'city', level: type})
    return this.each(function() {
      $(this).picker($.extend(defaultParmas, params))
    })
  }
})($)

const confirmBtnClass = (() => {
  let ID = 0
  return () => {
    ID++
    return `_cityPicker_confirmBtn${ID}`
  }
})()

let pickerConfirmClass = ''
let pickerConfirmButton = null

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    onopen: {
      type: Function
    },
    onclose: {
      type: Function
    },
    successBtn: {
      type: String,
      default: '确定'
    },
    cancelBtn: {
      type: String,
      default: '取消'
    },
    title: {
      type: String,
      default: ''
    },
    formatvalue: {
      type: Function,
      require: true
    },
    cityPicker: {
      type: Number,
      default: 3
    },
    cityValue: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  watch: {
    show: function(n, o) {
      this._showAndHide(n)
    }
  },
  mounted() {
    const proviceList = tuhu.localStorage.getItem('proviceList')
    if (proviceList) {
      try {
        this._cityPicker(JSON.parse(proviceList))
      } catch (error) {
        this._netWorkLoad()
      }
    } else {
      this._netWorkLoad()
    }
  },
  beforeDestroy() {
    $(this.$el).picker('close')
  },
  methods: {
    _cityPicker(proviceList) {
      pickerConfirmClass = confirmBtnClass()

      $(this.$el).cityPicker({
        toolbarTemplate: `<header class="bar bar-nav">
                            <button class="button button-link pull-right ${pickerConfirmClass} close-picker">${this.successBtn}</button>
                            <span class="subtitle">${this.title}</span>
                            <h1 class="title close-picker">${this.cancelBtn}</h1>
                          </header>`,
        formatValue: this.formatvalue,
        cityValue: this.cityValue,
        onOpen: this._onopen,
        onClose: this._onclose
      }, proviceList, this.cityPicker)

      this._showAndHide(this.show)
    },
    _netWorkLoad() {
      let $this = this
      // tuhu.fetch('https://www.xiaokunkeji.cn/api/queryProvinceCity').then((res) => {
      tuhu.fetch(`${config.apis.PROVINCE}`).then((res) => {
        if (res.code === '200') {
          const transformTree = data => {
            return data.map(item => ({
              id: item.id,
              name: item.areaName,
              children: item.children ? transformTree(item.children) : undefined
            }))
          }

          const r1 = transformTree(res.data)
		      const r2 = this.replace(r1)
          //   debugger
          tuhu.localStorage.setItem('proviceList', JSON.stringify(r2))
          try {
            $this._cityPicker(r2)
          } catch (error) {
			  console.log(error)
          }
        }
      })
	},
	replace (menus) {
		const fields = [{ name: 'ProviceName', id: 'RegionID', children: 'CityList' }, { name: 'CityName', id: 'RegionID', children: 'AreaList' }, { name: 'CityName', id: 'RegionID', children: '' }]
		const r = (menus, index) => {
			const field = fields[index]
			++index
			if (!field) return
			const arr = []
			for (let v of menus) {
				const item = {
					[field.id]: v.id,
					[field.name]: v.name
				}
				// if (['上海市', '北京市', '天津市', '重庆市'].indexOf(v.name) > -1) { // 不需要
				if ([].indexOf(v.name) > -1) {
					let res = []
					v.children.forEach((item) => {
						res.push({
							RegionID: item.id,
							CityName: item.name
						})
					})
					Object.assign(item, {CityList: [{
						CityName: v.name,
						RegionID: v.id,
						AreaList: res
					}]})
				} else {
					if (v.children && v.children.length) {
						field.children && (item[field.children] = r(v.children, index))
					}
				}
				arr.push(item)
			}
			return arr
		}
		return r(menus, 0)
	},
    _showAndHide(n) {
      n ? $(this.$el).picker('open') : $(this.$el).picker('close')
    },
    _onclose(picker) {
      this.onclose && this.onclose(picker)
    },
    _onopen(picker) {
      // 确认按钮注册事件
      pickerConfirmButton = picker.container.find(`.${pickerConfirmClass}.close-picker`)
      pickerConfirmButton.on('click', () => {
        this.$emit('onconfirm', picker)
      })

      this.onopen && this.onopen(picker)
    }
  },
  destroyed() {
    // 确认按钮注销事件
    pickerConfirmButton && pickerConfirmButton.off('click')
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// lib/components/citypicker.vue